module.exports = __webpack_public_path__ + "static/img/polidog_flag_left.f9011b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/polidog_flag_left.png
// module id = 16
// module chunks = 0